
import base from "./base.service";

const instance = base.service();

export const getAll = () => {
  return instance.get("/anketa/all");
};

export const getTokenByAnketa = (id) => {
  return instance.get(`/anketa/${id}/token`);
};

export const getByNaziv = (naslov) => {
     return instance.get(`/anketa/naziv/${encodeURIComponent(naslov)}`);
};

export const getIdByToken = (encryptedToken) => {
  return instance.get(`/anketa/by-token`, {
    params: {
      token: encryptedToken,
    },
  });
};
export const deleteAnketa = (id) => {
  return instance.delete(`/anketa/${id}`);
};

export const addAnketa = (novaAnketa) => {
  return instance.post(`/anketa`, novaAnketa);
};

export const updateAnketa = (id, updatedAnketa) => {
  return instance.put(`/anketa/${id}`, updatedAnketa);
};

export const getById = (id) => {
  return instance.get(`/anketa/${id}`);
};

export const getByStatusAndTip = (status, tip) => {
  return instance.get(`/anketa/${status}/${tip}`);
};

export const getPitanjaSaOdgovorima = (id) => {
  return instance.get(`/anketa/${id}/pitanja`);
};

export const getInstances = (id) => {
  return instance.get(`/anketa/${id}/instanceOdgovora`);
};

export default {
  getAll,
  deleteAnketa,
  addAnketa,
  getById,
  getPitanjaSaOdgovorima,
  updateAnketa,
  getByStatusAndTip,
  getTokenByAnketa,
  getIdByToken,
  getInstances,
  getByNaziv
};
